var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvertedComma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2559 0C49.844 1.47161 49.2559 2.35458 48.3738 2.94323C44.2575 5.29781 41.3173 8.53535 40.1412 13.5388C40.1412 14.1275 39.8472 15.0105 39.8472 15.5991C40.4352 15.8934 41.0233 15.8934 41.6113 15.8934C46.3157 17.0707 48.9619 21.1912 48.6679 26.489C48.3738 30.6095 44.8456 34.4357 40.4352 35.3187C32.2026 37.0846 26.0281 29.4323 26.9101 21.7799C28.0862 12.0672 34.2607 6.18077 42.4934 2.35458C44.8456 1.17729 46.9037 0.882968 49.2559 0Z",
    fill: "url(#paint0_linear_69_1072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2057 0.294922C22.4997 1.76653 22.2057 2.35518 21.0296 2.94382C16.9133 5.59273 13.679 8.83028 12.797 13.8338C12.797 14.4224 12.797 15.011 12.5029 15.5997C15.1492 16.1883 17.5013 16.777 18.9715 18.8372C22.7938 23.8407 22.2057 30.3158 17.5013 33.8477C12.5029 37.3796 5.44638 35.9079 2.21212 30.6101C-0.728113 26.1953 -0.434089 21.4861 1.33005 16.777C4.27029 8.53595 13.385 1.47221 22.2057 0.294922Z",
    fill: "url(#paint1_linear_69_1072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_69_1072",
    x1: 49.7209,
    y1: -0.640357,
    x2: 20.9119,
    y2: 4.59483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BA369C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70221,
    stopColor: "#7657C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3974ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_69_1072",
    x1: 22.5364,
    y1: -0.343679,
    x2: -5.84505,
    y2: 4.74708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E72181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#BA369C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70221,
    stopColor: "#7657C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3974ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedComma);
export default __webpack_public_path__ + "static/media/inverted_comma.5fe965a58be73693743236a57aa23e28.svg";
export { ForwardRef as ReactComponent };